import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { IDefaultLmsProfiles } from 'models/defaultLmsProfiles.model'
import { IGeneralAPI } from 'store/states/general.state'
import { Integration } from '../../models/integrations'

export const GENERAL_CONFIG_GET = 'GET_GENERAL_CONFIG'
export const GENERAL_CONFIG_GET_SUCCESS = 'GENERAL_CONFIG_GET_SUCCESS'
export const GENERAL_CONFIG_UPDATE = 'GENERAL_CONFIG_UPDATE'
export const GENERAL_CONFIG_UPDATE_SUCCESS = 'GENERAL_CONFIG_UPDATE_SUCCESS'
export const GENERAL_CONFIG_LOADING = 'GENERAL_CONFIG_LOADING'
export const GENERAL_LMS_PROFILES_DEFAULT_UPDATE =
  'GENERAL_LMS_PROFILES_DEFAULT_UPDATE'
export const GENERAL_LMS_PROFILES_DEFAULT_LIST =
  'GENERAL_LMS_PROFILES_DEFAULT_LIST'
export const GENERAL_LMS_PROFILES_DEFAULT_SUCCESS =
  'GENERAL_LMS_PROFILES_DEFAULT_SUCCESS'
export const GENERAL_INTEGRATIONS_LIST = 'GENERAL_INTEGRATIONS_LIST'
export const GENERAL_INTEGRATIONS_LIST_SUCCESS =
  'GENERAL_INTEGRATIONS_LIST_SUCCESS'

export const GENERAL_INTEGRATIONS_SET_LOADING =
  'GENERAL_INTEGRATIONS_SET_LOADING'

export type GeneralSuccess = {
  type: typeof GENERAL_CONFIG_GET_SUCCESS | typeof GENERAL_CONFIG_UPDATE_SUCCESS
  payload: IGeneralAPI
}

export type UpdateGeneral = {
  type: typeof GENERAL_CONFIG_UPDATE
  payload: Partial<IGeneralAPI>
}

export type Void = {
  type:
    | typeof GENERAL_CONFIG_GET
    | typeof GENERAL_CONFIG_UPDATE
    | typeof GENERAL_INTEGRATIONS_LIST
  payload: void
}

export type GeneralLoading = {
  type: typeof GENERAL_CONFIG_LOADING | typeof GENERAL_INTEGRATIONS_SET_LOADING
  payload: boolean
}

export type DefaultProfilesSuccess = {
  type: typeof GENERAL_LMS_PROFILES_DEFAULT_SUCCESS
  payload: IDefaultLmsProfiles[]
}

export type IntegrationsListSuccess = {
  type: typeof GENERAL_INTEGRATIONS_LIST_SUCCESS
  payload: Integration[]
}

export type ReducerActions =
  | GeneralSuccess
  | Void
  | GeneralLoading
  | DefaultProfilesSuccess
  | IntegrationsListSuccess

export const Actions = {
  get: () => createAction(GENERAL_CONFIG_GET),
  getSuccess: (data: IGeneralAPI): GeneralSuccess =>
    createAction(GENERAL_CONFIG_GET_SUCCESS, data),
  update: (data: UpdateGeneral['payload']) =>
    createAction(GENERAL_CONFIG_UPDATE, data),
  updateSuccess: (data: IGeneralAPI): GeneralSuccess =>
    createAction(GENERAL_CONFIG_UPDATE_SUCCESS, data),
  reload: () => createAction(GENERAL_CONFIG_GET),
  setLoading: (loading: boolean): GeneralLoading =>
    createAction(GENERAL_CONFIG_LOADING, loading),
  updateLmsProfilesDefault: (profilesIds: number[]) =>
    createAction(GENERAL_LMS_PROFILES_DEFAULT_UPDATE, profilesIds),
  lmsAllDefaultProfiles: () => createAction(GENERAL_LMS_PROFILES_DEFAULT_LIST),
  lmsAllDefaultProfilesSuccess: (data: DefaultProfilesSuccess['payload']) =>
    createAction(GENERAL_LMS_PROFILES_DEFAULT_SUCCESS, data),
  getIntegrationsList: () => createAction(GENERAL_INTEGRATIONS_LIST),
  getIntegrationsListSuccess: (data: IntegrationsListSuccess['payload']) =>
    createAction(GENERAL_INTEGRATIONS_LIST_SUCCESS, data),
  integrationsSetLoading: (loading: boolean) =>
    createAction(GENERAL_INTEGRATIONS_SET_LOADING, loading),
}

export type Actions = ActionsUnion<typeof Actions>
